import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import {
  getCampaignCode,
  getPartnerCode,
} from '@nibtravel/quote/common/features/loader';
import { ContentTypes, ZoneId } from '@nibtravel/shared/data-access/contentful';
import { QuoteActions, QuoteState } from '@nibtravel/shared/data-access/quote';
import { DomService } from '@nibtravel/shared/util/dom';
import { Features } from '@nibtravel/shared/util/feature-toggle';
import { take } from 'rxjs/operators';

import { HomeSelector } from './home.selector';

@Component({
  selector: 'nibtravel-home',
  templateUrl: './home.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent implements OnInit {
  ContentTypes = ContentTypes;
  Features = Features;
  ZoneId = ZoneId;

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store,
    private domService: DomService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.data.pipe(take(1)).subscribe((data) => {
      if (data?.tripType) {
        this.store.dispatch(new QuoteActions.SetQuoteType(data.tripType));
      }
    });

    this.activatedRoute.queryParamMap.pipe(take(1)).subscribe((params) => {
      const actions = [];
      const campaignCode = getCampaignCode(params);
      if (campaignCode) {
        actions.push(new QuoteActions.SetDefaultCampaignCode(campaignCode));
      }

      const partnerCode = getPartnerCode(params);
      if (partnerCode) {
        actions.push(new QuoteActions.SetPartnerCode(partnerCode));
      }

      const analytics = this.domService.getUtmParams();
      if (analytics) {
        actions.push(new QuoteActions.SetAnalyticParams(analytics));
      }

      if (actions.length) {
        this.store.dispatch(actions);
      }
    });

    const isPurchased = this.store.selectSnapshot(QuoteState.isPurchased);
    if (isPurchased) {
      this.store.dispatch(new QuoteActions.ResetQuote());
    }

    const isPolicyHolderDirty = this.store.selectSnapshot(
      HomeSelector.isPolicyHoldersDirty
    );
    if (isPolicyHolderDirty) {
      this.store.dispatch([
        new QuoteActions.ResetPolicyHolders(),
        new QuoteActions.ResetHomeAddress(),
      ]);
    }
  }
}
